<div>
  <section class="daily-report-section daily-dashboard-heading">
    <p class="qundis-ubuntu-32">Stillstandsmeldungen der letzten 24 Stunden für Produktionslinie {{
        userService.userProductionLineName()
      }}
    </p>
    <p class="qundis-ubuntu-14">Aktueller Zeitraum: {{ startDate() | date:'EEEEEE dd.MM.yyyy HH:mm' }} Uhr
      bis {{ endDate() | date:'EEEEEE dd.MM.yyyy HH:mm' }} Uhr</p>
  </section>
  <section class="dashboard-data-section">
    <div class="daily-report-section dashboard-report-table" *ngFor="let item of dashboardItems()">
      <app-report-card [heading]="item.heading">
        <div>
          <app-report-table
            [tableWidth]="'w-100'"
            [dataSource]="item.dataSource"
            [displayAll]="true"
            [tableHeading]="item.tableHeading"
            [tableHeadingClass]="item.tableHeadingClass"
            [displayedColumns]="item.displayedColumns"
            [columnWidths]="item.columnWidths"
          ></app-report-table>
        </div>
      </app-report-card>
    </div>
  </section>
</div>
